import React, { useContext, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { CurrentPortalContext } from '../../../context/Shared/CurrentPortal.context'
import { CurrentUserContext } from '../../../context/Shared/CurrentUser.context'
import { NotificationContext } from '../../../context/Shared/Notification.context'
import { theme } from '../../../styles/theme.style'
import { routify } from '../../../utils/functions'

/**
 * Route guard that restricts access based on portal role.
 * @param {string[]} allowedRoles - Roles permitted to access the route
 * @param {React.ReactNode} children - Route content to render if authorized
 * @param {string} [blockedMessage] - Optional message to show when access is denied
 */
export default function RoleGuard ({ allowedRoles, children, blockedMessage }) {
  const { portal } = useContext(CurrentPortalContext)
  const { me } = useContext(CurrentUserContext)
  const { setSnackBarMessage } = useContext(NotificationContext)

  const isBlocked =
    !(me?.admin && portal.role === 'Admin') &&
    !allowedRoles.includes(portal.role)

  useEffect(() => {
    if (isBlocked && blockedMessage) {
      setSnackBarMessage(blockedMessage, 'error')
    }
  }, [isBlocked, blockedMessage])

  // Admins viewing as 'Admin' role have full access
  if (me?.admin && portal.role === 'Admin') {
    return children
  }

  if (!allowedRoles.includes(portal.role)) {
    return <Navigate replace to={'/' + routify(theme.HOMEVU)} />
  }

  return children
}
